module.exports = function() {
    const owl = $('.banner-slider .owl-carousel');
    owl.owlCarousel({
        items:1,
        loop:true,
        smartSpeed:750,
        margin:0,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:false,
        dots:false,
        nav:false
    });

    $('.banner-slider .btn-next').on('click',function(){
        owl.trigger('next.owl.carousel')
    })
    $('.banner-slider .btn-prev').on('click',function(){
        owl.trigger('prev.owl.carousel')
    })

};